import(/* webpackMode: "eager" */ "/home/ubuntu/hs-med-billing/app/error.tsx");
